import { render, staticRenderFns } from "./DynamicTable.vue?vue&type=template&id=9da09efe&scoped=true"
import script from "./DynamicTable.vue?vue&type=script&lang=js"
export * from "./DynamicTable.vue?vue&type=script&lang=js"
import style0 from "./DynamicTable.vue?vue&type=style&index=0&id=9da09efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da09efe",
  null
  
)

export default component.exports